import { Link } from 'react-router-dom';
import { MarketingHeader } from '../../components/marketing/MarketingHeader';
import { MarketingFooter } from '../../components/marketing/MarketingFooter';
import { SEOHead } from '../../components/SEO/SEOHead';
import { StructuredData } from '../../components/SEO/StructuredData';
import { createBreadcrumbListSchema } from '../../components/SEO/StructuredData';

export const CareersPage = () => {
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://simcarlo.com';

  return (
    <div className="marketing-page">
      <SEOHead
        metadata={{
          title: 'Careers - Join Our Team',
          description: 'Join Simcarlo in making financial modeling accessible to everyone. We\'re looking for passionate people to help build tools that empower better decision-making.',
          keywords: ['careers', 'jobs', 'hiring', 'work at Simcarlo', 'financial modeling jobs'],
          ogImage: `${baseUrl}/images/Landing Main.png`,
          canonicalUrl: `${baseUrl}/careers`,
        }}
      />
      <StructuredData
        schemas={[
          createBreadcrumbListSchema([
            { name: 'Home', url: baseUrl },
            { name: 'Careers', url: `${baseUrl}/careers` },
          ]),
        ]}
      />
      <MarketingHeader />

      {/* Hero Section */}
      <section className="marketing-hero">
        <div className="marketing-container">
          <div className="marketing-hero-content">
            <div className="marketing-hero-text">
              <h1 className="marketing-hero-title">Careers</h1>
              <p className="marketing-hero-subtitle">Join us in making financial modeling accessible to everyone</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Work Here Section */}
      <section className="marketing-section">
        <div className="marketing-container">
          <h2 className="marketing-section-title">Why Work at Simcarlo?</h2>
          <p className="marketing-section-description">
            We're a small, passionate team building tools that help people make better decisions. 
            If you're excited about making complex problems simple and empowering users, we'd love to hear from you.
          </p>
          <div className="marketing-faq-grid">
            <div className="marketing-faq-item">
              <h3>Impact</h3>
              <p>Your work directly helps users make better financial decisions and understand uncertainty.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Growth</h3>
              <p>As an early-stage company, you'll have the opportunity to shape our product and culture.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Flexibility</h3>
              <p>We believe in work-life balance and offer flexible working arrangements.</p>
            </div>
            <div className="marketing-faq-item">
              <h3>Learning</h3>
              <p>Work with cutting-edge technologies and learn from experienced team members.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Open Positions Section */}
      <section className="marketing-section">
        <div className="marketing-container">
          <h2 className="marketing-section-title">Open Positions</h2>
          <p className="marketing-section-description">
            We're always looking for talented people to join our team. Even if you don't see a position 
            that matches your skills, we'd love to hear from you.
          </p>
          <div className="marketing-faq-grid">
            <div className="marketing-faq-item">
              <h3>No Open Positions at the Moment</h3>
              <p>We're not actively hiring right now, but we're always interested in connecting with talented people.</p>
              <p style={{ marginTop: '16px' }}>
                If you're passionate about financial modeling, user experience, or building great products, 
                please reach out. We keep promising candidates in mind for future opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="marketing-faq-cta">
        <div className="marketing-container">
          <div className="marketing-cta-content">
            <h2 className="marketing-section-title">Interested in Joining Us?</h2>
            <p className="marketing-section-description">Send us your resume and a note about why you're interested.</p>
            <div className="marketing-cta-buttons">
              <Link to="/contact" className="marketing-btn marketing-btn-primary marketing-btn-large">
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
};

